import { sampleData } from "../../../Routes/RenderPdf/sampleData";
import { seedConfigFromSample } from "../../../Routes/RenderPdf/seedConfig";

export function Default() {
  return {
    baseline: [],
    data: [],
    trendData: [],
    editable: false,
    reportType: "standard",
    isProcessing: false,
    dirty: false,
    trendDirty: false,
    saving: false,
    error: null,
    isDataFetched:false,
    pageCounts: {},
  };
}
